import React, { useState } from "react";

const Tab = ({
  tabs,
  btnClass,
  rightSide,
  btnDivClass,
  defaultActiveLabel,
  onTabChange,
}) => {
  const [activeTab, setActiveTab] = useState(
    defaultActiveLabel || tabs[0].label
  );

  const handleTabClick = (label) => {
    setActiveTab(label);
    onTabChange?.(label); // inform parent when tab changes
  };

  return (
    <div className="w-full mb-2">
      <div className={`flex ${btnDivClass} ${rightSide ? "justify-end" : ""}`}>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.label;
          const baseBtnClasses = `py-2 px-4 uppercase text-center text-base font-normal w-full duration-300 ${btnClass}`;
          const activeClasses = isActive
            ? "bg-navTheme text-white"
            : "text-themeBtn";

          return (
            <button
              key={tab.label}
              className={`${baseBtnClasses} ${activeClasses}`}
              onClick={() => handleTabClick(tab.label)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      <div>{tabs.find((tab) => tab.label === activeTab)?.content}</div>
    </div>
  );
};

export default Tab;
